import { useEffect, useState } from "react";
import "../../styles/global.css";
import { resourceLoader } from "../../utils/resourceLoader";

function Index(props) {
  const [showBackground, setShowBackground] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFirstLoadTimeout, setIsFirstLoadTimeout] = useState(false);
  useEffect(() => {
    if (isFirstLoad) {
      setTimeout(() => setIsFirstLoadTimeout(true), 800);
      setIsFirstLoad(false);
      return;
    }
    if (props.shouldShow) {
      setShowBackground(true);
    } else {
      setTimeout(() => setShowBackground(false), 150);
    }
  }, [props.shouldShow]);
  return (
    <div
      className={!showBackground ? "black" : "hbackground"}
      style={{
        "--content-bg": `url("${(props.shouldShow || !isFirstLoad) && resourceLoader.getResource("hbg").url}")`,
      }}
    >
      <div
        className="home-index-introduction"
        style={{
          opacity: `${isFirstLoadTimeout && !(isFirstLoad || !props.shouldShow) ? 1 : 0}`,
        }}
      >
        <p className="home-index-introduction-text-1">梦想于此萌芽</p>
        <p className="home-index-introduction-text-2">天地源公会</p>
        <p className="home-index-introduction-text-3">
          天地源公会是一个在忘了多少年前成立的mc公会，在这里你会见到红石大佬，建筑大佬还有pvp大佬，编不下去了（）
        </p>
        <a
          class="home-index-join-btn"
          id="joinButton"
          href="https://qm.qq.com/q/ODELlFJ7cQ"
          target="_blank"
          rel="noreferrer"
        >
          <span class="material-icons">auto_awesome</span>
          &nbsp;加入我们
        </a>
      </div>
      <div className="home-scroll-container">
        <p className="home-scroll-text">SCROLL</p>
        <i className="fas fa-angle-down home-scroll-icon"></i>
      </div>
    </div>
  );
}

export default Index;
